import React from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import "./NavBar.css";
import { FaBars } from "react-icons/fa";
import profile from "../../images/profile.png";
import dashboard from "../../images/dashboard.png";
import deadline from "../../images/deadline.png";
import forms from "../../images/forms.png";
import pay from "../../images/payment-icon.png";
import { useSelector } from "react-redux";

const SideBar = () => {
  const { id } = useParams();
  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const client = useSelector((state) => state.fetchedClient);

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div>
        <FaBars className="toggle" onClick={handleToggleCollapse} />
      </div>
      <div className="avatar-container">
        <img
          src={profile}
          className="avatar-image"
          alt="Avatar"
          style={{ width: "50px", height: "50px" }}
        />
        <div className="avatar-name">{client?.firstName || "Loading..."}</div>
      </div>

      <NavLink to={`/${id}`} activeClassName="active" exact={true}>
        <div className="nav-img-container">
          <img
            src={dashboard}
            style={{ width: "20px", height: "20px" }}
            alt="Dashboard"
          />
        </div>
        {!isCollapsed && <span>Dashboard</span>}
      </NavLink>

      <NavLink to={`/forms/${id}`} activeClassName="active">
        <div
          className="nav-img-container"
          style={{ display: "flex" }}
        >
          <img
            src={forms}
            style={{ width: "22px", height: "22px" }}
            alt="Forms"
          />
        </div>
        {!isCollapsed && <span>Forms</span>}
      </NavLink>

      <NavLink to={`/appointments/${id}`} activeClassName="active">
        <div className="nav-img-container">
          <img
            src={deadline}
            style={{ width: "22px", height: "22px" }}
            alt="Appointments"
          />
        </div>
        {!isCollapsed && <span>Appointments</span>}
      </NavLink>
      {/* <NavLink to={`/payment/${id}`} activeClassName="active">
        <div className="nav-img-container">
          <img
            src={pay}
            style={{ width: "22px", height: "22px" }}
            alt="Appointments"
          />
        </div>
        {!isCollapsed && <span>Payment History</span>}
      </NavLink> */}
    </div>
  );
};

export default SideBar;
